import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiFetch } from '@/api/client';
import styles from './Sidebar.module.css';

type RecentRecord = {
  record_type: string;
  record_id: string;
  title: string;
  viewed_at: string;
};

function recordHref(r: RecentRecord): string {
  if (r.record_type === 'lead') return `/app/leads?lead=${r.record_id}`;
  if (r.record_type === 'deal') return `/app/pipeline?deal=${r.record_id}`;
  return `/app/accounts?account=${r.record_id}`;
}

export function RecentRecords() {
  const q = useQuery({
    queryKey: ['recent-records'],
    queryFn: () => apiFetch<{ records: RecentRecord[] }>('/api/platform/recent-records'),
  });
  const records = q.data?.records ?? [];
  if (!records.length) return null;

  return (
    <div>
      <div className={styles.sectionTitle}>Recent</div>
      <ul className={styles.navList}>
        {records.map((r) => (
          <li key={`${r.record_type}-${r.record_id}`}>
            <Link to={recordHref(r)} className={styles.navLink} title={r.title}>
              {r.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
